import convertPersonaToRecipientViewState from './convertPersonaToRecipientViewState';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import findReadWriteRecipient from 'owa-readwrite-recipient-well/lib/actions/findReadWriteRecipient';
import isValidEmailAddress from 'owa-recipient-common/lib/utils/isValidEmailAddress';
import parseSuspectedDisplayNameEmailAddress from 'owa-readwrite-recipient-well/lib/utils/parseSuspectedDisplayNameEmailAddress';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import updateQueryString from '../actions/updateQueryString';
import createFindControlViewState from 'owa-recipient-common/lib/utils/createFindControlViewState';
import { splitPasteInputIntoRecipientStrings } from './splitPasteInputIntoRecipientStrings';

export default async function parseTextForRecipient(
    recipientWell: FindControlViewState,
    text: string,
    strict: boolean
): Promise<ReadWriteRecipientViewState> {
    let trimmedText = text.trim();
    if (trimmedText.length > 0) {
        // try to parse out a suspected name + email address combo
        let recipient = parseSuspectedDisplayNameEmailAddress(trimmedText);
        let isResolved = false;

        const emailAddress = recipient.EmailAddress.EmailAddress;
        if (!strict || isValidEmailAddress(emailAddress)) {
            await findReadWriteRecipient(recipientWell, emailAddress, true /* searchDirectory */);

            if (recipientWell.findResultSet.length === 1) {
                const result = recipientWell.findResultSet[0];
                if (!strict || result.EmailAddress.EmailAddress == emailAddress) {
                    recipient = result;
                    isResolved = true;
                }
            }
        }

        return convertPersonaToRecipientViewState([recipient], !isResolved /*validationNeeded*/)[0];
    }

    return null;
}

export async function parsePastedTextForRecipients(
    recipientWell: FindControlViewState,
    pastedText: string
): Promise<ReadWriteRecipientViewState[]> {
    let recipientParsingPromises = [];
    let recipientList = splitPasteInputIntoRecipientStrings(pastedText);
    for (let recipientText of recipientList) {
        updateQueryString(recipientWell, recipientText);
        recipientParsingPromises.push(
            parseTextForRecipient(
                createFindControlViewState(recipientText),
                recipientText,
                false /*strict*/
            )
        );
    }

    return await Promise.all(recipientParsingPromises);
}
